import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

interface ResultProps {
  title: string;
  subtitle: string;
  status?: 'success' | 'error' | 'info' | 'warning'
}

const ResultPage: React.FC<ResultProps> = ({ title, subtitle, status }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/dashboard');
  };

  return (
    <div style={{ backgroundColor: 'white', height: '100%', minHeight: '440px' }}>
    <Result
      status={ status ?? "success"}
      title={title}
      subTitle={subtitle}
      extra={[
        <Button key="buy" onClick={handleClick}>Dashboard</Button>,
      ]}
    />
    </div>
  );
};

export default ResultPage;
